<template>
	<v-container fluid>
		<v-row align="center">
			<v-progress-circular
				indeterminate
				v-if="loading"
				class="my-orange mx-auto"
			></v-progress-circular>
		</v-row>

		<!-- Header com busca no estilo da referência -->
		<v-row
			justify="center"
			align="center"
			style="
				position: sticky;
				top: 0px;
				background-color: #f2f2f2;
				z-index: 5;
				box-shadow: 0px 4px 7px -4px rgba(0, 0, 0, 0.5);
			"
			class="pa-4"
		>
			<!-- Botão voltar -->
			<v-col
				cols="12"
				md="2"
				class="d-flex justify-start"
			>
				<v-btn
					text
					@click="$router.go(-1)"
					color="#F15A24"
				>
					<v-icon class="mr-1">mdi-chevron-left</v-icon>
					VOLTAR
				</v-btn>
			</v-col>

			<!-- Campo de busca -->
			<v-col
				cols="12"
				md="7"
				class="d-flex justify-center"
			>
				<v-text-field
					hide-details="true"
					v-model="buscaModel"
					style="max-width: 100%; width: 100%"
					outlined
					dense
					color="#F15A24"
					background-color="white"
					prepend-inner-icon="mdi-magnify"
					placeholder="Faça uma busca por algum termo específico"
					label="Faça uma busca por algum termo específico"
					@keyup.enter="buscarLei"
				></v-text-field>
			</v-col>

			<!-- Botão de busca (volta a ser o original) -->
			<v-col
				cols="12"
				md="3"
				class="d-flex justify-start"
			>
				<v-btn
					color="#F15A24"
					dark
					style="text-transform: none"
					@click="buscarLei"
				>
					<v-icon class="mr-1">mdi-magnify</v-icon>
					Buscar
				</v-btn>
			</v-col>
		</v-row>

		<!-- Conteúdo da lei (mantido original) -->
		<v-row>
			<v-col
				cols="12"
				md="6"
				class="d-flex align-center"
			>
				<h2 class="my-orange gt-bold mb-0">{{ lei.numero_lei }}</h2>
			</v-col>

			<v-col
				cols="12"
				md="12"
			>
				<p class="font-weight-light">{{ lei.nome_lei }}</p>
			</v-col>
		</v-row>

		<v-row>
			<v-col>
				<DynamicScroller
					id="conteudos"
					ref="conteudos"
					class="scroller"
					:items="conteudos"
					key-field="id_reg"
					:min-item-size="54"
				>
					<template v-slot:default="{ item, index, active }">
						<DynamicScrollerItem
							:item="item"
							:data-index="item.id_reg"
							:active="active"
							:size-dependencies="[item.conteudo, item.anotacoes]"
						>
							<v-col
								class="rowAnnotation"
								cols="12"
								:style="{
									backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white',
								}"
							>
								<p
									v-html="item.conteudo"
									:id="item.id_reg"
									:style="item.strike ? 'text-decoration: line-through' : ''"
								></p>
								<v-list
									v-if="item.anotacoes"
									style="background-color: transparent"
								>
									<v-list-item
										class="flex-column d-flex justify-center pa-3"
										v-for="(a, a_index) in item.anotacoes"
										:key="a.id"
										:id="a.id"
									>
										<v-card
											width="100%"
											elevation="1"
										>
											<v-card-title
												class="annotation d-flex flex-row align-center justify-space-between"
											>
												<p class="d-flex align-center mb-0">
													<img
														width="30px"
														class="rounded-circle mr-1"
														:src="
															a.user_created.avatar
																? `https://api.mylegis.com.br/assets/${a.user_created.avatar}`
																: require('../assets/icon-person.svg')
														"
													/>
													{{ a.user_created.first_name }} em
													{{ a.date_created | brdatetime }}
												</p>
												<p class="d-flex justify-end mb-0">
													<v-btn
														@click="editAnnotation(item, a)"
														text
													>
														<v-icon>mdi-pencil</v-icon></v-btn
													>
													<v-btn
														@click="
															confirm = true;
															delAnnotation = {
																aId: a.id,
																cIndex: index,
																aIndex: a_index,
															};
														"
														text
														><v-icon>mdi-delete</v-icon></v-btn
													>
												</p>
											</v-card-title>
											<v-card-text>
												<p
													class="d-flex flex-column annotation"
													v-html="a.texto"
												></p>
												<small class="pr-4">
													<span v-if="a.status === `group`">
														<v-icon>mdi-account-group</v-icon>
														{{ a.id_grupo.nome_grupo }}
													</span>
													<span v-else>
														<v-icon small>{{
															a.status === `private` ? `mdi-lock` : `mdi-earth`
														}}</v-icon>
														{{ a.status | filterStatus }}
													</span>
													-
													<v-icon small>mdi-clock-outline</v-icon>
													{{
														a.date_updated === null
															? 'Criado em'
															: 'Atualizado em'
													}}
													{{
														a.date_updated === null
															? a.date_created
															: a.date_updated | brdatetime
													}}
													-
													<span :style="{ opacity: a.id_vademecum ? 1 : 0.1 }">
														<v-avatar
															size="15"
															v-if="a.id_vademecum"
															:color="
																a.id_vademecum.cor
																	? a.id_vademecum.cor
																	: `#f57029`
															"
														>
														</v-avatar>
														{{
															!a.id_vademecum
																? `nenhum vade-mécum`
																: a.id_vademecum.titulo
														}}
													</span>
												</small>
											</v-card-text>
										</v-card>
									</v-list-item>
								</v-list>
								<div>
									<p class="d-flex justify-end">
										<v-btn
											:disabled="user.plano === `plano-free`"
											class="mt-5"
											@click="newAnnotation(item)"
											text
											style="color: #f15a24"
											>Nova Anotação <v-icon>mdi-plus</v-icon></v-btn
										>
									</p>
								</div>
							</v-col>
						</DynamicScrollerItem>
					</template>
				</DynamicScroller>
				<!-- </v-virtual-scroll> -->
			</v-col>
		</v-row>

		<v-row>
			<v-col>
				<label
					class="tag-sm mx-1"
					v-for="(t, i) in lei.tags"
					:key="i"
				>
					<input
						type="checkbox"
						disabled
						class="tag-sm-checkbox"
					/>
					<span class="tag-sm-container">
						<span class="tag-sm-content">
							<span>{{ t }}</span>
							<span class="tag-sm-icon"></span>
						</span>
					</span>
				</label>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<p class="font-weight-light">
					Fonte:
					<span class="my-orange"> {{ lei.esfera_lei }}</span>
				</p>
			</v-col>
		</v-row>
		<v-divider
			class="my-5 mb-7"
			color="#f57029"
		></v-divider>
		<!-- <v-row>
			<v-col>
				<h3 class="my-orange gt-bold mb-2 d-flex- align-center">
					<img width="30px" class="mr-3" src="../assets/icon-talkbubble.svg" />
					{{
						comentarios.length > 0
						? comentarios.length +
						" Comentário" + (comentarios.length > 1 ? "s" : "")
						: "Nenhum comentário público"
					}}
				</h3>
			</v-col>
		</v-row>

		<v-row class="mx-1 mb-3">
			<v-col v-for="p in comentarios" :key="p.id" cols="12"
				class="pa-10 d-flex flex-row align-left justify-start grey lighten-3"
				:class="intBreakPoint <= 0 ? 'flex-column' : 'flex-row'">
				<avatar-dpo :user="p.user_created"> </avatar-dpo>

				<p class="text-left font-weight-light">
					<span>
						<h3 class="my-orange gt-bold mb-0">
							{{
								p.user_created.first_name +
								" " +
								p.user_created.last_name !== null ? p.user_created.last_name : ``
							}}
						</h3>
					</span>
					<span>{{ p.date_created | brdatetime }}</span><br />
					<span class="comentario" v-html="p.mensagem"></span>
				</p>
			</v-col>
		</v-row>
		<v-row class="mx-0">
			<v-col cols="12" class="pt-5 px-0 d-flex flex-column align-end">
				<h4 class="text-left mb-n1 my-orange gt-bold" style="width: 100%">
					Novo Comentário
				</h4>
				<div style="width: 100%; margin: 10px 0px">
					<VueEditor ref="editor1" color="#F15A24" :editor-toolbar="customToolbar1"
						@image-added="handleImageAdded" use-custom-image-handler v-model="comentario" />
				</div>
				<v-btn class="float-right" dark color="#F15A24" @click="enviarComentario">
					Enviar
				</v-btn>
			</v-col>
		</v-row> -->
		<v-dialog
			width="700px"
			v-model="showNewAnnotation"
		>
			<v-card class="px-5">
				<v-card-title class="px-0"
					>Nova Anotação <v-spacer />
					<v-btn
						@click="showNewAnnotation = false"
						text
						><v-icon large>mdi-close</v-icon></v-btn
					></v-card-title
				>
				<v-card-text>
					<h3></h3>
					<p
						class="pa-2"
						style="border: 1px dashed #f15a24"
						v-html="conteudoSelected.conteudo"
					></p>
					<h3>Vade-mécum</h3>
					<v-select
						color="#F15A24"
						:items="vadeMecuns"
						v-model="annotation.id_vademecum"
						item-text="titulo"
						item-value="id"
					>
						<!-- <template v-slot:prepend-item="[item]">
							{{ item.id }}
						</template> -->
					</v-select>
					<h3>Visibilidade</h3>
					<v-select
						color="#F15A24"
						:items="
							user.plano === `plano-free` || user.plano === null
								? statusFreeAnnotation
								: statusAnnotation
						"
						v-model="annotation.status"
					></v-select>
					<h3 v-if="annotation.status == `group`">Selecione o grupo</h3>
					<v-select
						v-if="annotation.status == `group`"
						item-text="grupos_id.nome_grupo"
						item-value="grupos_id.id"
						color="#F15A24"
						:items="groups"
						v-model="annotation.id_grupo"
					></v-select>
					<v-row class="align-center">
						<v-col
							cols="12"
							sm="auto"
							class="d-flex align-center"
						>
							<h3>Conteúdo</h3>
						</v-col>
						<v-col
							cols="12"
							sm="auto"
							class="d-flex flex-wrap justify-end flex-grow-1"
						>
							<v-btn
								text
								small
								@click="undo"
								class="ma-1"
								><v-icon>mdi-undo</v-icon> Desfazer</v-btn
							>
							<v-btn
								@click="redo"
								text
								small
								class="ma-1"
								><v-icon>mdi-redo</v-icon> Refazer</v-btn
							>
						</v-col>
						<v-col
							cols="12"
							sm="auto"
							class="d-flex justify-end"
						>
							<v-file-input
								v-model="files"
								placeholder="Adicionar Arquivo"
								flat
								:prepend-icon="'mdi-plus'"
								@change="newFile"
								color="#F15A24"
								class="ma-1"
								hide-details
								dense
							></v-file-input>
						</v-col>
					</v-row>
					<VueEditor
						use-custom-image-handler
						@image-added="handleImageAdded"
						ref="editor"
						color="#F15A24"
						:editor-toolbar="customToolbar"
						v-model="annotation.texto"
					/>
					<div class="d-flex align-center my-4 justify-space-between">
						<v-btn
							color="#f15a24"
							:outlined="!recording || !recorded"
							:text="recording || recorded"
							:disabled="recording || recorded"
							@click="recordAudio"
						>
							<v-icon>mdi-microphone</v-icon>
							{{ recording || recorded ? `` : `Gravar Áudio` }}
						</v-btn>
						<v-btn
							v-if="recorded"
							@click="deleteRecording"
							text
							><v-icon>mdi-trash-can</v-icon></v-btn
						>

						<div
							id="recordings"
							class="mx-3 pa-0"
							style="height: 36px"
						></div>
						<p
							v-if="recording"
							class="mb-0"
						>
							gravando... {{ timeRecording }}s
						</p>
						<v-btn
							color="#f15a24"
							v-if="recording"
							@click="stopRecording"
							outlined
							class="mt-2"
							>Finalizar <v-icon class="ml-2">mdi-send</v-icon></v-btn
						>
						<v-btn
							color="#f15a24"
							v-if="recorded"
							@click="saveRecording"
							outlined
							class="mt-1"
							:loading="loadingUploadRecording"
							>Anexar <v-icon class="ml-2">mdi-attachment-plus</v-icon></v-btn
						>
					</div>
				</v-card-text>
				<v-card-actions class="justify-end px-0">
					<v-btn
						text
						@click="showNewAnnotation = false"
						>Cancelar</v-btn
					>
					<v-btn
						:loading="loadingNewAnnotation"
						dark
						@click="saveNewAnnotation()"
						color="#F15A24"
						>Salvar
						<v-icon
							class="ml-1"
							small
							>mdi-content-save</v-icon
						></v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			width="700px"
			v-model="showBusca"
		>
			<v-card class="px-5">
				<v-card-title class="px-0"
					>Busca interna - {{ buscaModel }} <v-spacer />
					<v-btn
						@click="showBusca = false"
						text
						><v-icon large>mdi-close</v-icon></v-btn
					></v-card-title
				>
				<v-card-text>
					<p
						v-for="l in resultadoBusca"
						:key="l.id_reg"
					>
						<span v-html="highlight(l.conteudo, buscaModel)"> </span>
						<v-btn
							@click="gotoRef(l.id_reg)"
							text
							color="#f15a24"
							>Ir até
							<v-icon
								color="#f15a24"
								small
								>mdi-arrow-down-right</v-icon
							></v-btn
						>
					</p>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="confirm"
			width="25vw"
		>
			<v-card>
				<v-card-title> Remover Anotação </v-card-title>
				<v-card-text>
					<v-row>
						<v-col
							cols="12"
							md="12"
						>
							<h2 style="gap: 1rem; color: #f15a24">
								<v-icon>mdi-account-trash</v-icon>Você tem certeza que deseja
								remover está anotação ?<br />
								<small class="black--text text-caption"
									>Obs: Está ação é irreversível.
								</small>
							</h2>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="justify-end">
					<v-btn
						text
						@click="confirm = false"
					>
						Cancelar
					</v-btn>

					<v-btn
						color="#F15A24"
						:loading="loadingDelete"
						@click="deleteAnnotation()"
						dark
					>
						Remover
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <div>
			<canvas id="map"></canvas>
		</div> -->
	</v-container>
</template>
<style scoped>
	.scroller {
		height: 500px;
		overflow-y: auto;
		/* border: 2px dashed rgba(132, 8, 8, 0.406); */
	}

	#map {
		position: fixed;
		top: 110px;
		right: 0;
		width: 80px;
		min-width: 80px;
		height: 100%;
		z-index: 100;
	}

	a {
		color: #f15a24;
	}

	.rowHovered {
		/* border-radius: 2px; */
		/* border: 1px solid #f15a24; */
		cursor: pointer;
		background-color: #f7f7f7;
	}

	.annotation {
		background-color: #f15a2405;
		/* border: 1px dashed #f15a24; */
	}

	.rowAnnotation:hover {
		cursor: pointer;
		background-color: #f7f7f7;
	}

	.annotation ::v-deep img,
	.comentario ::v-deep img {
		max-width: 100% !important;
	}

	.annotation ::v-deep iframe {
		height: 250px;
	}

	.annotation p {
		margin-bottom: 0px !important;
	}
	audio {
		height: 36px !important;
	}
</style>
<script>
	// import AvatarDpo from "../components/AvatarDpo.vue";
	import { VueEditor, Quill } from 'vue2-editor';
	// import BtnCompartilhar from "../components/BtnCompartilahr.vue";
	// import pagemap from "pagemap";
	import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';
	import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
	// import VuetifyAudio from 'vuetify-audio';

	const BlockEmbed = Quill.import('blots/block/embed');

	class AudioBlot extends BlockEmbed {
		static blotName = 'audio';
		static tagName = 'audio';

		static create(value) {
			const node = super.create();
			node.setAttribute('alt', value.alt);
			node.setAttribute('src', value.url);
			return node;
		}

		static value(node) {
			return {
				alt: node.getAttribute('alt'),
				url: node.getAttribute('src'),
			};
		}
	}
	Quill.register(AudioBlot);
	export default {
		name: 'ConteudoNoticia',
		components: { VueEditor, DynamicScroller, DynamicScrollerItem },
		data() {
			return {
				idAnotacao: '',
				selectedVds: [],
				panel: [],
				isActive: false,
				files: [],
				annotation: { status: 'private', texto: '' },
				delAnnotation: {},
				annotationVisible: '',
				anotacoes: [],
				showBusca: false,
				resultadoBusca: [],
				confirm: false,
				buscaModel: '',
				showNewAnnotation: false,
				conteudoSelected: {},
				conteudos: [],
				comentarios: {},
				avatar: {},
				comentario: '',
				idLei: 0,
				loading: false,
				loadingNewAnnotation: false,
				loadingDelete: false,
				lei: {},
				statusAnnotation: [
					{ text: 'Público', value: 'published' },
					{ text: 'Grupo', value: 'group' },
					{ text: 'Privado', value: 'private' },
					{ text: 'Apenas Amigos', value: 'friend' },
					{ text: 'Arquivado', value: 'archived' },
				],
				statusFreeAnnotation: [
					{ text: 'Grupo', value: 'group' },
					{ text: 'Privado', value: 'private' },
					{ text: 'Apenas Amigos', value: 'friend' },
					{ text: 'Arquivado', value: 'archived' },
				],
				customToolbar: [
					[{ font: [] }, { size: [] }],
					['bold', 'italic', 'underline', 'strike'],
					[{ color: [] }, { background: [] }],
					// [{ script: "super" }, { script: "sub" }],

					[
						{ list: 'ordered' },
						{ list: 'bullet' },
						{ indent: '-1' },
						{ indent: '+1' },
					],
					['direction', { align: [] }],
					['link', 'image', 'video'],
					['clean'],
				],
				customToolbar1: [
					[{ font: [] }, { size: [] }],
					['bold', 'italic', 'underline', 'strike'],
					[{ color: [] }, { background: [] }],
					// [{ script: "super" }, { script: "sub" }],
					// [{ header: "1" }, { header: "2" }, "blockquote"],
					[
						{ list: 'ordered' },
						{ list: 'bullet' },
						{ indent: '-1' },
						{ indent: '+1' },
					],
					['direction', { align: [] }],
					['link', 'image', 'video'],
					['clean'],
				],
				recordBlob: null,
				recording: false,
				recorded: false,
				loadingUploadRecording: false,
				countRecording: null,
				timeRecording: 0,
				mediaRecorder: null,
				chunks: [],
			};
		},
		async created() {
			this.$store.dispatch('realoadVadeMecuns');

			this.idLei = this.$route.params.idLei;
			let selectVade = this.$route.params.vadeMecun;
			if (this.idLei) {
				this.loading = true;
				this.$http({ url: 'items/leis/' + this.idLei }).then((data) => {
					this.lei = data.data.data;
				});
				this.$http({
					url:
						'items/conteudoleis/?limit=-1&sort=sort,id_reg&filter[id_lei][_eq]=' +
						this.idLei,
				}).then((data) => {
					// window.console.log(data.data.data)
					this.conteudos = data.data.data;
					if (selectVade) {
						let vademecun = this.vadeMecuns.filter(
							(e) => this.sanitizeTitle(e.titulo) == selectVade
						);

						if (vademecun[0]) {
							window.console.log(vademecun[0].id);
							this.selectedVds.push({
								id: vademecun[0].id,
								titulo: vademecun[0].titulo,
							});
						}
					}
					this.reloadAnotacoes();
					// this.reloadComentarios();
					this.loading = false;
				});
			}
		},
		mounted() {
			// pagemap(document.querySelector("#map"), {
			// 	viewport: null,
			// 	styles: {
			// 		p: "rgba(0,0,0,0.08)",
			// 		".annotation": "#F15A24",
			// 		"h2,h3,h4": "rgba(0,0,0,0.08)",
			// 	},
			// 	back: "rgba(0,0,0,0.02)",
			// 	view: "rgba(0,0,0,0.05)",
			// 	drag: "rgba(0,0,0,0.10)",
			// 	interval: 50,
			// });
		},
		computed: {
			user() {
				return this.$store.state.user;
			},
			groups() {
				return this.$store.state.filteredGroups;
			},
			vadeMecuns() {
				return this.$store.state.vadeMecuns;
			},
			editor() {
				return this.$refs.editor.quill;
			},
			intBreakPoint() {
				switch (this.$vuetify.breakpoint.name) {
					case 'xs':
						return 0;
					case 'sm':
						return 1;
					case 'md':
						return 2;
					case 'lg':
						return 3;
					case 'xl':
						return 4;
					default:
						return 0;
				}
			},
		},
		methods: {
			saveRecording() {
				this.loadingUploadRecording = true;
				var formData = new FormData();
				formData.append('file', this.recordBlob, 'audio.ogg');
				this.$http
					.post('/files', formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
						},
					})
					.then((response) => {
						this.loadingUploadRecording = false;
						let dt = response.data.data;
						if (this.annotation.texto === undefined) {
							this.annotation.texto = '';
						}
						this.annotation.texto += `<audio controls src='https://api.mylegis.com.br/assets/${dt.id}'></audio>`;
						this.deleteRecording();
					});
			},
			deleteRecording() {
				this.recorded = false;
				this.recordBlob = null;
				var recordingsElement = document.getElementById('recordings');
				recordingsElement.innerHTML = '';
				clearInterval(this.countRecording);
				this.timeRecording = 0;
			},
			stopRecording() {
				this.recording = false;
				// window.console.log("stopped");
				if (this.mediaRecorder) this.mediaRecorder.stop();
				this.recorded = true;
			},
			recordAudio() {
				this.recording = true;
				navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
					this.mediaRecorder = new MediaRecorder(stream);
					this.chunks = [];
					this.mediaRecorder.start(1000);
					this.countRecording = setInterval(() => {
						this.timeRecording++;
					}, 1000);
					this.mediaRecorder.addEventListener('dataavailable', (event) => {
						// window.console.log(event.data)
						this.chunks.push(event.data);
					});

					this.mediaRecorder.addEventListener('stop', () => {
						var recordingsElement = document.getElementById('recordings');
						var audioElement = document.createElement('audio');
						audioElement.setAttribute('controls', '');
						recordingsElement.appendChild(audioElement);
						audioElement.controls = true;
						this.recordBlob = new Blob(this.chunks, {
							type: 'audio/ogg; codecs=opus',
						});
						this.chunks = [];
						audioElement.src = window.URL.createObjectURL(this.recordBlob);
						this.mediaRecorder = null;
						this.timeRecording = 0;

						clearInterval(this.countRecording);
					});
				});
			},
			newFile() {
				window.console.log(this.files);
				if (this.files) {
					if (confirm('Você deseja adicionar este arquivo a esta anotação? ')) {
						var formData = new FormData();
						formData.append('file', this.files);
						this.$http
							.post('/files', formData, {
								headers: {
									'Content-Type': 'multipart/form-data',
								},
							})
							.then((response) => {
								let dt = response.data.data;
								if (this.annotation.texto === undefined) {
									this.annotation.texto = '';
								}
								// window.console.log(this.annotation.texto)
								this.annotation.texto += `<a href='https://api.mylegis.com.br/assets/${dt.id}?download' target='_blank' style='border:1px solid gray; padding:5px;'>${dt.filename_download}</a>`;
								// window.console.log(dt)
								// this.$forceUpdate()
							});
					}
					this.files = null;
				}
			},
			gotoRef(refName) {
				var position = this.conteudos.find((e) => e.id_reg == refName);
				// window.console.log(refName)
				// // var top = document.getElementById(refName);
				// window.console.log({refName, position})
				// window.console.log(this.conteudos[0].id_reg)
				// window.console.log(this.$refs )
				window.console.log({ refName, position });
				// this.$refs.conteudos.$el.scrollTo({ top: position * 100, behavior: "smooth" })
				if (position) {
					this.$refs.conteudos.scrollToItem(position.sort);
					this.showBusca = false;
					window.scrollTo({ top: 200, behavior: 'smooth' });
				}
			},
			highlight(content, query) {
				if (!query) {
					return content;
				}
				return content.replace(new RegExp(query, 'gi'), (match) => {
					return '<span class="my-orange">' + match + '</span>';
				});
			},
			clear() {
				this.editor.history.clear();
			},
			undo() {
				this.editor.history.undo();
			},
			redo() {
				this.editor.history.redo();
			},
			buscarLei() {
				this.$http
					.get(
						`items/conteudoleis/?search=` +
							this.buscaModel +
							`&filter[id_lei][_eq]=` +
							this.idLei
					)
					.then((res) => {
						this.resultadoBusca = res.data.data;
						this.showBusca = true;
					});
			},
			handleImageAdded(file, Editor, cursorLocation) {
				window.console.log(file);
				const formData = new FormData();
				formData.append('image', file);
				this.$http
					.post('/files', formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
						},
					})
					.then((response) => {
						window.console.log(response);
						let url = `https://api.mylegis.com.br/assets/${response.data.data.id}`;
						Editor.insertEmbed(cursorLocation, 'image', url);
					})
					.catch((err) => {
						window.console.log(err);
					});
			},
			deleteAnnotation() {
				const id = this.delAnnotation.aId;
				const cIndex = this.delAnnotation.cIndex;
				const aIndex = this.delAnnotation.aIndex;
				this.loadingDelete = true;
				this.$http
					.patch(`/items/anotacoes/${id}`, {
						status: 'archived',
					})
					.then(() => {
						//this.reloadAnotacoes();
						this.delAnnotation = {};
						this.confirm = false;
						this.conteudos[cIndex].anotacoes.splice(aIndex, 1);
						this.loadingDelete = false;
					});
			},
			editAnnotation(c, annotation) {
				this.conteudoSelected = { ...c };
				this.annotation = annotation;
				this.showNewAnnotation = true;
			},
			newAnnotation(c) {
				this.conteudoSelected = { ...c };
				this.showNewAnnotation = true;
			},
			saveNewAnnotation() {
				this.loadingNewAnnotation = true;
				let dt = {
					id_lei: this.idLei,
					id_reg: this.conteudoSelected.id_reg,
					status: this.annotation.status,
					id_grupo: this.annotation.id_grupo,
					texto: this.annotation.texto,
					id_vademecum: this.annotation.id_vademecum,
				};
				if (!dt.id_vademecum) {
					alert('Por favor escolha um vade-mécun');
					this.loadingNewAnnotation = false;
					return;
				}
				if (dt.texto.length == 0) {
					alert('Por favor insira um conteúdo na anotação');
					this.loadingNewAnnotation = false;

					return;
				}
				if (this.annotation.id === undefined) {
					this.$http
						.post('items/anotacoes', dt)
						.then((response) => {
							if (response.data.data.id != undefined) {
								// this.reloadAnotacoes();
								this.loadingNewAnnotation = false;
								this.showNewAnnotation = false;
								(this.annotation = { status: 'private', texto: '' }),
									(this.conteudoSelected = {});
								this.clear();

								let conteudo = this.conteudos.find(
									(el) => el.id_reg === dt.id_reg
								);
								let vdselected = this.vadeMecuns.filter((e) => {
									return e.id === dt.id_vademecum;
								})[0];
								let resData = { ...response.data.data };
								resData.id_vademecum = null;
								resData.id_vademecum = {
									id: this.annotation.id_vademecum,
									titulo: vdselected.titulo,
									cor: vdselected.cor,
								};
								if (conteudo.anotacoes)
									conteudo.anotacoes.push({
										...resData,
										user_created: this.user,
									});
								else
									conteudo.anotacoes = [
										{ ...resData, user_created: this.user },
									];
							}
						})
						.catch(() => {
							this.loadingNewAnnotation = false;
						});
				} else {
					this.$http
						.patch('items/anotacoes/' + this.annotation.id, dt)
						.then((response) => {
							if (response.data.data.id != undefined) {
								// this.reloadAnotacoes();
								this.loadingNewAnnotation = false;
								this.showNewAnnotation = false;
								this.annotation = { status: 'private' };
								this.conteudoSelected = {};
								this.clearAnotacoes();
								this.reloadAnotacoes();
							}
						})
						.catch(() => {
							this.loadingNewAnnotation = false;
						});
				}
			},
			clearAnotacoes(reload) {
				this.conteudos.forEach((el) => (el.anotacoes = []));
				if (reload) this.reloadAnotacoes();
			},
			reloadAnotacoes() {
				let filters = '';

				//&filter[_and][0][_and][0][id_vademecum][_in][0]=2fd8cb4f-9662-4c5f-8642-afda00791c62
				//&filter[_and][0][_and][0][id_vademecum][_in][1]=cfdd3911-eaff-46ac-bd8c-ad2a5c3511a1
				//&filter[_and][1][status][_neq]=archived&
				if (this.selectedVds.length > 0) {
					this.selectedVds.forEach((e, index) => {
						filters += `&filter[_and][0][_and][0][id_vademecum][_in][${index}]=${e.id}`;
					});
					filters += `&filter[_and][1][status][_neq]=archived`;
				} else {
					filters += `&filter[status][_neq]=archived`;
				}
				// window.console.log(filters)
				this.$http({
					url: `items/anotacoes/?fields=*,user_created.avatar,user_created.first_name,user_created.last_name,id_vademecum.*&filter[id_lei][_eq]=${this.idLei}&filter[user_created][_eq]=${this.$store.state.user.id}${filters}`,
				}).then((data) => {
					this.anotacoes = data.data.data;
					this.anotacoes.forEach((anotacao) => {
						let conteudo = this.conteudos.find(
							(el) => el.id_reg === anotacao.id_reg
						);
						if (conteudo) {
							if (conteudo.anotacoes) conteudo.anotacoes.push(anotacao);
							else conteudo.anotacoes = [anotacao];
						}
					});
					// this.$forceUpdate();
					const searchParams = new URLSearchParams(window.location.search);
					if (searchParams.get('id')) {
						this.gotoRef(searchParams.get('id'));
					}
				});
			},
			reloadComentarios() {
				this.comentarios = [];
				this.$http({
					url:
						'items/comentario_artigo/?fields=*,user_created.avatar,user_created.first_name,user_created.last_name&filter[id_lei][_eq]=' +
						this.idLei,
				}).then((data) => {
					this.comentarios = data.data.data;
				});
			},
			enviarComentario() {
				if (this.comentario === '') {
					window.alert('Por favor digite um comentário');
					return;
				}

				let comm = {
					id_lei: this.idLei,
					mensagem: this.comentario,
					status: 'published',
				};

				this.$http.post('items/comentario_artigo', comm).then((response) => {
					if (response.data.data.id != undefined) {
						this.reloadComentarios();
						this.comentario = '';
					}
				});
			},
			all() {
				this.panel = Array.from(Array(this.anotacoes.length).keys());
			},
			none() {
				this.panel = [];
			},
			sanitizeTitle(title) {
				var slug = '';
				// Change to lower case
				var titleLower = title.toLowerCase();
				// Letter "e"
				slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
				// Letter "a"
				slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
				// Letter "o"
				slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
				// Letter "u"
				slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
				// Letter "d"
				slug = slug.replace(/đ/gi, 'd');
				// Trim the last whitespace
				slug = slug.replace(/\s*$/g, '');
				// Change whitespace to "-"
				slug = slug.replace(/\s+/g, '-');

				return slug;
			},
		},
	};
</script>
